module.exports = __webpack_public_path__ + "static/img/10.736f3189.png";